import { render, staticRenderFns } from "./PersonNameForm.vue?vue&type=template&id=b07ac98a"
import script from "./PersonNameForm.vue?vue&type=script&lang=js"
export * from "./PersonNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports